module.exports = __webpack_public_path__ + "static/media/home-print.4adb6454.png";